import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import Select from '../../../../components/form/AppSelect';
import { api } from '../../../../shared/api';
import { BUNDLES_API } from './usePacking';

const unitLabel = (qr, serial, stockName) =>
  [qr, serial, stockName].filter(Boolean).join(' · ');

/** Optional choice of the physical box (QR label) for a project case; lists boxes free in the project's dates. */
const CaseUnitPicker = ({ bundle, onChange, disabled }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { data: units = [], isFetching } = useQuery({
    queryKey: ['available-case-units', bundle.id],
    queryFn: () => api.get(`${BUNDLES_API}${bundle.id}/available_case_units/`),
    enabled: open,
  });

  const current = bundle.case_unit
    ? { value: bundle.case_unit, label: unitLabel(bundle.case_unit_qr, null, bundle.case_unit_stock_name) }
    : null;
  const options = units.map((unit) => ({
    value: unit.id,
    label: unitLabel(unit.qr_code, unit.serial_number, unit.stock_name),
  }));

  return (
    <Select
      inputId={`case-unit-${bundle.id}`}
      aria-label={t('projects.cases.caseUnit')}
      placeholder={t('projects.cases.caseUnitPlaceholder')}
      value={current}
      options={options}
      isLoading={isFetching}
      isClearable
      isDisabled={disabled}
      onMenuOpen={() => setOpen(true)}
      onChange={(option) => onChange(option ? option.value : null)}
      noOptionsMessage={() => t('projects.cases.caseUnitNone')}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1060 }) }}
    />
  );
};

export default CaseUnitPicker;
